import { FC, ReactNode, useMemo } from "react";
import { SimpleActivity } from "@ac-expo/api-types";
import { PlanningEvent } from "../planning";
import { ActivityDetails } from "./ActivityDetails";

interface ActivityDetailsModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedActivities?: PlanningEvent[];
  activities: SimpleActivity[];
  getActivityCartPart?: (activityId: string) => ReactNode;
  searchBar?: ReactNode;
  getRegisterButton?: (activityId: string) => ReactNode;
  onClose?: () => void;
}

export const ActivityDetailsModal: FC<ActivityDetailsModalProps> = ({
  open,
  setOpen,
  selectedActivities,
  activities,
  getActivityCartPart,
  searchBar,
  getRegisterButton,
  onClose,
}) => {
  const filteredActivities = useMemo(() => {
    if (selectedActivities && selectedActivities.length > 0) {
      return activities.filter((activity) =>
        selectedActivities.some(
          (selected) => selected.activityId === activity.id
        )
      );
    }
    return activities;
  }, [activities, selectedActivities]);

  const handleOpenChange = (open: boolean) => {
    setOpen(open);
    if (!open && onClose) {
      onClose();
    }
  };

  if (selectedActivities && selectedActivities.length === 0) {
    return null;
  }

  return (
    <ActivityDetails
      open={open}
      onOpenChange={handleOpenChange}
      activities={filteredActivities}
      getActivityCartPart={getActivityCartPart}
      searchBar={searchBar}
      getRegisterButton={getRegisterButton}
    />
  );
};
